const encodeHTML = (html) => {
    const txt = document.createElement('textarea');
    txt.innerText = html;
    return txt.innerHTML;
};
export default encodeHTML;
